/**
 * Message lisible pour le caissier à partir d'une réponse d'erreur du backend CardLife.
 * Le backend place le message métier (ex. refus du Core Banking) dans `userMessage`.
 */
export function messageErreurApi(status: number, corps: string, parDefaut: string): string {
  try {
    const json = JSON.parse(corps);
    if (typeof json?.userMessage === 'string' && json.userMessage.trim()) return json.userMessage.trim();
  } catch {
    // corps non JSON
  }
  if (status === 401 || status === 403) return 'Votre session a expiré ou vos droits sont insuffisants : reconnectez-vous.';
  if (status >= 500) return `${parDefaut} Le serveur est momentanément indisponible, réessayez dans quelques instants.`;
  return `${parDefaut} (erreur ${status}).`;
}
